import { render, staticRenderFns } from "./Sfcheck-table.vue?vue&type=template&id=5412b096"
import script from "./Sfcheck-table.vue?vue&type=script&lang=js"
export * from "./Sfcheck-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports